import Button from "../../../common/components/input/Button/Button";
import Icon from "../../../common/components/Icon/Icon";
import FlexRow from "../../../common/components/layout/Flexbox/FlexRow";
import TextInput from "../../../common/components/input/TextInput/TextInput";

import { useRef } from "react";

import magnifier from "../../../assets/images/common/svg/magnifier.svg";

import "./WikiSearchBar_style.css";

type Props = Readonly<{
    srcString?: string;
    onSearchStringChanged?: (val: string) => void;
    onSearchSubmitted?: (val: string) => void;
}>;

export default function WikiSearchBar({
    srcString,
    onSearchStringChanged,
    onSearchSubmitted,
}: Props): JSX.Element {
    const searchString = useRef<string>(srcString ?? "");

    return (
        <FlexRow gap={4}>
            <TextInput placeholderText="Search Wiki..."
                value={searchString.current}
                onChange={(val) => {
                    searchString.current = val;
                    onSearchStringChanged?.(val);
                }}
                onEnterKeyPress={() => {
                    onSearchSubmitted?.(searchString.current);
                }} style={{color: (searchString.current?.length ?? 0) === 0 ? '#666' : undefined}}
            />
            <Button
                onClick={() => {
                    onSearchSubmitted?.(searchString.current);
                }}
                icon={magnifier}
            />
        </FlexRow>
    );
}
